import axiosInstance from 'integration/api/axiosInstance';
import {
  CreateOnlineHoursData,
  OnlineHoursDto,
  UpdateOnlineHoursData,
} from 'common/types/onlineHours';

/**
 * API for managing online hours of professionals.
 */
export const OnlineHoursAPI = {
  /**
   * Fetches the online hours for a given professional ID.
   *
   * @param id - The ID of the professional to fetch the online hours for.
   * @returns An Axios response containing the online hours data.
   */
  fetchOnlineHours: (id: string) => {
    return axiosInstance.get<OnlineHoursDto>(
      `/professionals/${id}/online-hours`,
    );
  },

  /**
   * Creates new online hours for a given professional ID.
   *
   * @param id - The ID of the professional to create the online hours for.
   * @param data - An object containing the details of the new online hours.
   * @returns An Axios response indicating success or failure.
   */
  createOnlineHours: ({ id, data }: CreateOnlineHoursData) => {
    return axiosInstance.post(`/professionals/${id}/online-hours`, data);
  },

  /**
   * Updates the existing online hours for a given professional ID.
   *
   * @param id - The ID of the professional to update the online hours for.
   * @param data - An object containing the updated details of the online hours.
   * @returns An Axios response indicating success or failure.
   */
  updateOnlineHours: ({ id, data }: UpdateOnlineHoursData) => {
    return axiosInstance.patch(`/professionals/${id}/online-hours`, data);
  },
};
